import React, { useCallback } from "react";
import useEditableCell from "@/react/components/table/useEditableCell";
import { cellErrors, KEY } from "@/react/components/table/useTableMutations";
import { AddressSelector } from "@/react/features/smp/address-management/AddressSelector";

export function addressSelectorCellFactory(addressIdColumnKey) {
  return (addressCell) => {
    const errors = cellErrors(addressCell);
    const { value: address, onChange: onChangeAddress } =
      useEditableCell(addressCell);

    const addressIdCell = addressCell.row
      .getAllCells()
      .find((c) => c.column.id === addressIdColumnKey)
      ?.getContext();
    const { value: addressId, onChange: onChangeAddressId } =
      useEditableCell(addressIdCell);

    const { updateRows, skipAutoResetPageIndex, schema } =
      addressCell.table.options.meta;

    const onBlur = useCallback(() => {
      skipAutoResetPageIndex();
      updateRows(
        [addressCell.row.original[KEY]],
        new Map([
          [addressIdColumnKey, addressId],
          [addressCell.column.id, address],
        ]),
        schema
      );
    }, [
      addressCell,
      addressId,
      addressIdColumnKey,
      schema,
      skipAutoResetPageIndex,
      updateRows,
    ]);

    return (
      <AddressSelector
        addressId={addressId}
        address={address}
        onChangeAddressId={onChangeAddressId}
        onChangeAddress={onChangeAddress}
        onBlur={onBlur}
        errors={errors}
      />
    );
  };
}
